/** The product identity is separate from the upstream repository name. */
export const APP_NAME = 'Jack OS';
